export default __webpack_public_path__ + "static/media/PreConfig.08d1dba8.png";